export default __webpack_public_path__ + "static/media/ukIcon.4839cec4.svg";